import type React from 'react';
import { useMemo } from 'react';

import { useCardsFilters } from '@vlabs/monokit/entities/cards/filters/useCardsFilters';
import { FilterMenuButton } from '@vlabs/monokit/shared/ui/filter-menu';

import { hasIntersection } from './hasIntersections';
import type { GetCardsFilterKeys } from '@vlabs/api/types';

interface CardListFilterMenuButtonProps {
  exclude?: GetCardsFilterKeys;
}

function CardListFilterMenuButton({
  exclude = undefined,
}: CardListFilterMenuButtonProps): React.JSX.Element {
  const { filters } = useCardsFilters();
  const filtersCount = useMemo(() => {
    const isExcluded = (filterKeys: GetCardsFilterKeys) => hasIntersection<GetCardsFilterKeys>(exclude, filterKeys);
    let count = 0;
    if (!isExcluded(['card_ids', 'card_id__gte', 'card_id__lt', 'card_id__ilike', 'card_id__like']) && (
      filters.card_ids
      || filters.card_id__gte || filters.card_id__lt
      || filters.card_id__ilike || filters.card_id__like)) {
      count += 1;
    }
    if (!isExcluded(['create_time__gte', 'create_time__lt']) && (
      filters.create_time__gte || filters.create_time__lt)) {
      count += 1;
    }
    if (!isExcluded(['user_data.fio__eq', 'user_data.fio__ilike', 'user_data.fio__like']) && (
      filters['user_data.fio__eq'] || filters['user_data.fio__ilike'] || filters['user_data.fio__like'])) {
      count += 1;
    }
    if (!isExcluded(['list_ids']) && filters.list_ids) count += 1;
    return count;
  }, [filters, exclude]);

  return <FilterMenuButton filtersCount={filtersCount} />;
}

export { CardListFilterMenuButton };
